import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export enum ErpConfigKey {
    autoPaymentRequestsEnabled = 'autoPaymentRequestsEnabled',
    invoiceCutoffDate = 'invoiceCutoffDate',
    invoiceCutoffPeriod = 'invoiceCutoffPeriod',
}

export enum InvoiceCutoffPeriod {
    NoCutoff = 'no-cutoff',
    LastMonth = '1',
    Last3Months = '3',
    Last6Months = '6',
    LastYear = '12',
}

export const ErpConfigSchema = z.discriminatedUnion('key', [
    z.object({
        key: z.literal(ErpConfigKey.autoPaymentRequestsEnabled),
        value: z.boolean(),
    }),
    z.object({
        key: z.literal(ErpConfigKey.invoiceCutoffDate),
        value: z.string().nullable(),
    }),
    z.object({
        key: z.literal(ErpConfigKey.invoiceCutoffPeriod),
        value: z.nativeEnum(InvoiceCutoffPeriod).nullable(),
    }),
]);

export class ErpConfigUpdate extends FromSchema(ErpConfigSchema) {
    key: ErpConfigKey;
    value: any;
}

export type ErpConfig = {
    [K in ErpConfigKey]?: any;
};
